angular.module('admin.directives')
  .directive('homeFacts', ['HomeService', '$q', 'HelperService',
    function (HomeService, $q, helpers) {
      return {
        restrict: 'E',
        controllerAs: 'homeFactsCtrl',
        bindToController: {
          homeId: '=?',
          formContents: '@',
          factSet: '@',
          onSaved: '&',
          onCancel: '&',
          onDelete: '&',
          showDelete: '=?',
          home: '=',
          answers: '=?'
        },
        scope: {},
        templateUrl: '/admin/templates/partials/home-facts.html',

        controller: function () {
          let ctrl = this
          ctrl.maxDate = moment()
          ctrl.minDate = moment('1776-07-04', helpers.dateFormat)

          const findAnswer = question => _.result(_.find(ctrl.answers, 'question', question), 'answer')
          const integerLoader = name => () => parseInt(findAnswer(editableFacts[name].question) || ctrl.home[name] || 0)
          const bathroomsLoader = () => {
            try {
              const answer = findAnswer(editableFacts.bathrooms.question)
              return _.mapValues(JSON.parse(`{${answer}}`), parseInt)
            } catch (err) {
              return {}
            }
          }
          const dateLoader = () => {
            const question = editableFacts.soldDate.question
            const unparsedDate = findAnswer(question) || ctrl.home.soldDate;
            const m = moment(unparsedDate, helpers.dateFormat)
            return {
              day: m.date(),
              month: m.month() + 1,
              year: m.year()
            }
          }

          const factSets = {
            physical: {
              bathrooms: {
                loader: bathroomsLoader,
                answerCreator: fact => JSON.stringify(fact).replace(/[{}]/g, ''),
                question: 'fact:bathrooms'
              },
              bedrooms: {
                loader: integerLoader('bedrooms'),
                answerCreator: _.identity,
                question: 'fact:bedrooms'
              },
              finishedSqFt: {
                loader: integerLoader('finishedSqFt'),
                answerCreator: _.identity,
                question: 'fact:finishedSqFt'
              }
            },
            sale: {
              soldPrice: {
                loader: integerLoader('soldPrice'),
                answerCreator: _.identity,
                question: 'fact:soldPrice'
              },
              soldDate: {
                loader: dateLoader,
                answerCreator: ({year, month, day}) => `${year}-${month}-${day}`,
                question: 'fact:soldDate',
                inputValidator: ({year, month, day}) => {
                  const m = moment({year, month: month - 1, day})
                  if (!m.isValid()) throw `Please enter a valid month, day and year.`
                  if (m.isAfter(ctrl.maxDate)) throw `You cannot enter a date in the future.`
                  if (m.isBefore(ctrl.minDate)) throw `Please enter a date after July 4th, 1776.`
                }
              }
            }
          }

          const editableFacts = Object.assign({}, factSets.physical, factSets.sale)
          const selectedFactNames = Object.keys(factSets[ctrl.factSet])
          const selectedQuestions = selectedFactNames.map(name => editableFacts[name].question)

          ctrl.submit = () => {
            ctrl.successful = null
            ctrl.error = null
            ctrl.add()
          }

          const parseForSaving = () => {
            return selectedFactNames.reduce((answers, factName) => {
              const {question, answerCreator, inputValidator} = editableFacts[factName]
              const newFact = ctrl.facts[factName]

              if (!_.isEqual(newFact, ctrl.originalFacts[factName])) {
                if (inputValidator) inputValidator(newFact)
                answers[question] = answerCreator(newFact)
              }

              return answers
            }, {})
          }

          ctrl.cancel = () => {
            ctrl.facts = _.cloneDeep(ctrl.originalFacts)
            ctrl.facts.bathrooms = bathroomDefaults()
            ctrl.error = null
            ctrl.onCancel()
          }

          ctrl.add = () => {
            let answers = {}

            try {
              answers = parseForSaving()
            } catch (e) {
              error(e)
              return
            }

            ctrl.saving = true
            HomeService.saveAnswers(answers, ctrl.homeId)
              .then(success)
              .catch(error)
          }

          ctrl.deleteAnswers = function () {
            if (!confirm('Are you sure you want to reset to Homebot data?')) { return }

            ctrl.saving = true
            ctrl.error = ''

            const deleteRequests = ctrl.answers.reduce((answersToDelete, answer) => {
              const answerSelectedForDelete = selectedQuestions.indexOf(answer.question) >= 0
              return answerSelectedForDelete ?
                answersToDelete.concat(HomeService.deleteAnswer(answer.id, ctrl.homeId)) :
                answersToDelete
            }, [])

            $q.all(deleteRequests)
              .then(() => HomeService.recompileHome(ctrl.homeId))
              .then(home => ctrl.home = home)
              .then(success)
              .catch(error)
          }

          const success = savedHome => {
            ctrl.successful = true
            ctrl.error = null
            ctrl.saving = false
            savedHome && ctrl.resetAdd()
            ctrl.onSaved()
          };

          const error = err => {
            ctrl.error = (typeof err === 'string') ? err : 'There was an error saving your home facts. Please try again or contact support.'
            ctrl.saving = false
          };

          const bathroomDefaults = () => {
            const baths = ctrl.facts.bathrooms
            return {
              full: typeof baths.full !== 'undefined' ? baths.full : parseInt(ctrl.home.bathrooms),
              threeQuarters: baths.threeQuarters || 0,
              half: baths.half || 0,
              quarter: baths.quarter || 0
            }
          }

          const loadAnswers = () => {
            if (!ctrl.homeId) { return }

            ctrl.facts = {}

            HomeService.getAnswers(ctrl.homeId)
              .then(unsortedAnswers => {
                const sortedAnswers = _.sortByOrder(unsortedAnswers, 'updated', 'desc');
                const questions = Object.values(editableFacts).map(({question}) => question)
                ctrl.answers = _.filter(sortedAnswers, ({question}) => questions.indexOf(question) >= 0)
                Object.keys(editableFacts).forEach(name => ctrl.facts[name] = editableFacts[name].loader())
                ctrl.originalFacts = _.cloneDeep(ctrl.facts)
                ctrl.facts.bathrooms = bathroomDefaults();
                ctrl.showDelete = ctrl.answers.length > 0
                ctrl.loading = false
              })
              .catch(err => utils.trackException('Admin view home answers', err))
          }

          ctrl.resetAdd = () => {
            ctrl.showDelete = false
            loadAnswers()
          }

          ctrl.resetAdd()
        }
      }
    }
  ])
